import { CloseOutlined } from '@ant-design/icons';
import { Modal, Row } from 'antd';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'react-jss';
import Api from '../Api';
import styles from '../styles';

const SummaryModal = props => {
  const { getValues, setModal, classes } = props;

  const colorIds = useSelector(state => state.colorIds);
  const productIds = useSelector(state => state.productIds);

  const closeModal = () => setModal(false);

  const [Fabrics, SetFabrics] = useState([]);

  const fabricMap = useMemo(() => {
    const map = new Map();

    Fabrics.forEach(fabric => {
      map.set(+fabric.id, fabric);
    });

    return map;
  }, [Fabrics]);

  const productMap = useMemo(() => {
    const map = new Map();

    productIds.forEach(product => {
      map.set(+product.id, product);
    });

    return map;
  }, [productIds]);

  const colorMap = useMemo(() => {
    const map = new Map();

    colorIds.forEach(color => {
      map.set(+color.id, color);
    });

    return map;
  }, [colorIds]);

  const summary = useMemo(() => {
    const jobchartProducts = getValues('products') || [];

    const fabricCombinations = new Map();

    const fabricIds = new Set();

    jobchartProducts.forEach(product => {
      (product.styles || []).forEach(style => {
        (style.fabrics || []).forEach(fabric => {
          if (!fabric?.fabricId) {
            return;
          }

          fabricIds.add(fabric.fabricId);

          const uId = `p${product.productId || null}f${
            fabric.fabricId || null
          }b${fabric.baseColorId || null}pc${fabric.printColorId || null}`;

          fabricCombinations.set(
            uId,
            (fabricCombinations.get(uId) || 0) + fabric.totalQuantity
          );
        });
      });
    });

    Api.get('/fabrics', { ids: [...fabricIds] })
      .then(({ data }) => SetFabrics(data))
      .catch(console.error);

    return fabricCombinations;
  }, [getValues('products')]);

  return (
    <Modal
      centered
      visible
      maskClosable={false}
      okText="Close"
      onOk={closeModal}
      cancelButtonProps={{ style: { display: 'none' } }}
      width={1200}
      title="Fabric Summary"
      closeIcon={<CloseOutlined onClick={closeModal} />}
    >
      <Row>
        <table className={classes.inputTable}>
          <thead className={classes.inputThead}>
            <tr>
              <th className={classes.inputTh}>Product</th>
              <th className={classes.inputTh}>Fabric</th>
              <th className={classes.inputTh}>Width</th>
              <th className={classes.inputTh}>Base Color</th>
              <th className={classes.inputTh}>Print Color</th>
              <th className={classes.inputTh}>Total Quantity</th>
            </tr>
          </thead>
          <tbody>
            {[...summary.keys()].map((key, index) => {
              const value = summary.get(key);

              const productId =
                +key.substring(key.indexOf('p') + 1, key.indexOf('f')) || null;

              const fabricId =
                +key.substring(key.indexOf('f') + 1, key.indexOf('b')) || null;

              const baseColorId =
                +key.substring(key.indexOf('b') + 1, key.indexOf('pc')) || null;

              const printColorId =
                +key.substring(key.indexOf('pc') + 1) || null;

              return (
                <tr key={index}>
                  <td className={classes.inputTd}>
                    {productMap.get(+productId)?.name}
                  </td>
                  <td className={classes.inputTd}>
                    {fabricMap.get(+fabricId)?.name}
                  </td>
                  <td className={classes.inputTd}>
                    {fabricMap.get(+fabricId)?.width}
                  </td>
                  <td className={classes.inputTd}>
                    {colorMap.get(+baseColorId)?.color}
                  </td>
                  <td className={classes.inputTd}>
                    {colorMap.get(+printColorId)?.color}
                  </td>
                  <td className={classes.inputTd}>{+value.toFixed(3)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Row>
    </Modal>
  );
};

SummaryModal.propTypes = {
  getValues: PropTypes.func.isRequired,
  setModal: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SummaryModal);
